import React from 'react'
import { AccessibilityRole } from 'react-native'
import { CardVariant, StyledTouchableOpacity, StyledView } from './style'

type CardProps = {
  children: React.ReactNode
  onPress?: () => void
  disabled?: boolean
  style?: object
  testID: string
  accessibilityLabel?: string
  accessibilityRole?: AccessibilityRole
  analyticsName?: string
  variant?: CardVariant
}

const Card = ({
  children,
  onPress = undefined,
  disabled = false,
  style = {},
  testID,
  accessibilityLabel,
  accessibilityRole,
  analyticsName,
  variant,
}: CardProps) => {
  if (onPress) {
    return (
      <StyledTouchableOpacity
        onPress={onPress}
        disabled={disabled}
        style={style}
        testID={testID}
        accessibilityLabel={accessibilityLabel || undefined}
        accessibilityRole={accessibilityRole}
        analyticsName={analyticsName}
        variant={variant}
      >
        {children}
      </StyledTouchableOpacity>
    )
  } else {
    return (
      <StyledView
        style={style}
        testID={testID}
        accessibilityLabel={accessibilityLabel || undefined}
        accessibilityRole={accessibilityRole}
        variant={variant}
      >
        {children}
      </StyledView>
    )
  }
}

export default Card
